import { urlApi } from '../config'
import { getAccessToken } from '../auth'

const readBody = async response => {
  try {
    if (typeof response.text === 'function') {
      const text = await response.text()
      if (!text) return null
      try {
        return JSON.parse(text)
      } catch {
        return text
      }
    }
    if (typeof response.json === 'function') return await response.json()
  } catch {
    return null
  }
  return null
}

const readToken = async () => {
  try {
    return await getAccessToken()
  } catch {
    return null
  }
}

export default async function adminRequest(path, { method = 'GET', body, signal } = {}) {
  const token = await readToken()
  const hasBody = body !== undefined
  let response
  try {
    response = await fetch(`${urlApi}${path}`, {
      method,
      credentials: 'include',
      signal,
      headers: {
        ...(hasBody && { 'Content-Type': 'application/json' }),
        ...(typeof token === 'string' && { Authorization: `Bearer ${token}` })
      },
      ...(hasBody && { body: JSON.stringify(body) })
    })
  } catch (error) {
    return {
      ok: false,
      status: 0,
      data: null,
      networkError: true,
      aborted: error?.name === 'AbortError'
    }
  }
  const data = await readBody(response)
  return { ok: Boolean(response.ok), status: response.status, data }
}
